import { render } from "./DriveDetail.vue?vue&type=template&id=18d5118a&ts=true"
import script from "./DriveDetail.vue?vue&type=script&lang=ts"
export * from "./DriveDetail.vue?vue&type=script&lang=ts"

import "./DriveDetail.vue?vue&type=style&index=0&id=18d5118a&lang=css"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__